import React, { useState } from 'react';

import { ACH_PROXY_PREFIX } from '../../constants/ach/proxy';
import { achApiHostMap, apiHostMap } from '../../constants/config';
import { useConfig } from '../../hooks/useConfig';

// Dev-only, display-only panel: shows which API host the app is currently
// pointed at (and the VITE_API_ENV that selected it), and turns red when that
// host is production so it is obvious you are hitting prod data. There is no env
// switcher — the environment is chosen via VITE_API_ENV in .env.
function DebugView() {
  const { apiHost, achApiHost } = useConfig();
  const [isOpen, setIsOpen] = useState(false);

  if (!import.meta.env.DEV) {
    return null;
  }

  const isProduction = apiHost === apiHostMap.production;

  // When ACH is routed through the dev proxy, also show where the proxy forwards
  // to. Mirrors vite.config.ts: the upstream is achApiHostMap[VITE_API_ENV],
  // defaulting to sandbox when unset/invalid.
  const isAchProxied = achApiHost === ACH_PROXY_PREFIX;
  const achProxyTarget = achApiHostMap[import.meta.env.VITE_API_ENV] || achApiHostMap.sandbox;

  return (
    <div
      style={{
        position: 'fixed',
        display: 'inline',
        padding: `${isOpen ? '5px' : '0'}`,
        right: '0',
        top: '200px',
        backgroundColor: isProduction ? 'red' : 'white',
        border: `${isOpen ? '1px solid black' : 'none'}`,
        borderRadius: '5px 5px 5px 5px',
        width: `${isOpen ? '250px' : '0px'}`,
        zIndex: '9999',
        textAlign: 'center',
        lineHeight: '23px',
      }}
    >
      {isOpen ? (
        <div className="contents" style={{ display: 'inline-block', margin: '5px auto' }}>
          <div>VITE_API_ENV: {import.meta.env.VITE_API_ENV || '(unset)'}</div>
          <br />
          <div>API: {apiHost}</div>
          <br />
          <div>ACH: {achApiHost}</div>
          {isAchProxied ? <div>→ {achProxyTarget}</div> : null}
        </div>
      ) : null}
      <button
        className="collapse-btn"
        type="button"
        style={{
          position: 'absolute',
          top: '30px',
          left: '-30px',
          height: '30px',
          backgroundColor: isProduction ? 'red' : 'white',
          borderLeft: '1px solid black',
          borderTop: '1px solid black',
          borderRight: '0',
          borderBottom: '1px solid black',
          borderRadius: '5px 0px 0px 5px',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span
          style={{
            fontSize: '1.5em',
          }}
        >
          {isOpen ? '▶' : '◀'}
        </span>
      </button>
    </div>
  );
}

export default DebugView;
